<template>
  <div class="animated fadeIn">
    <!-- Modal Component -->
    <b-modal
      ref="reviewModal"
      lazy
      ok-only
      :title="modalTitle"
      size="lg"
    >
      <longterm-report
        v-if="modalLongterm"
        :email="email"
        :longterm="0"
        :apply-id="modalApplyId"
        :lock="true"
        :initial-read-only="true"
        :no-edit="true"
      />
      <apply-info
        v-else
        :email="email"
        :apply-id="modalApplyId"
        :lock="true"
        :initial-read-only="true"
        :no-edit="true"
      />
    </b-modal>
    <b-row
      align-h="center"
      class="text-left"
    >
      <b-col md="12">
        <h4>과거 신청 기록</h4>
      </b-col>
    </b-row>
    <b-row no-gutters="">
      <b-col
        v-for="(record, idx) in pastRecords"
        :key="idx"
        md="2"
      >
        <table>
          <th>{{ record.applyId.substring(0, 8) }}</th>
          <tr>{{ record.longterm === 0 ? record.schlsType : '장기장학' }}</tr>
          <tr>
            <b-button
              variant="link"
              @click="getPastReview(record)"
            >
              {{ record.longterm === 0 ? '신청서 보기' : '레포트 보기' }}
            </b-button>
          </tr>
        </table>
      </b-col>
      <b-col
        v-if="pastRecords.length === 0"
        md="12"
        class="text-left"
      >
        ------------------- 없음 -------------------
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <hr>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'
import ApplyInfo from '../apply/ApplyInfo'
import LongtermReport from '../apply/LongtermReport'

export default {
  name: 'RemnantPastApply',
  components: { ApplyInfo, LongtermReport },
  props: {
    email: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      pastRecords: [],
      modalLongterm: false,
      modalTitle: '',
      modalApplyId: ''
    }
  },
  mounted () {
    if (this.email !== '') {
      this.getDetailInfo(1)
    }
  },
  methods: {
    getPastReview (record) {
      this.modalTitle = record.applyId.substring(0, 8)
      this.modalApplyId = record.applyId
      this.modalLongterm = record.longterm
      this.$refs.reviewModal.show()
    },
    parseDetailInfo (data) {
      this.pastRecords = []
      data.docs.forEach(doc => {
        if (doc.applyId.substring(0, 8) !== api.currentTerm()) {
          this.pastRecords.push(doc)
        }
      })
    },
    getDetailInfo (info) {
      api.request('get', '/admin/apply/past?' + 'email=' + this.email + '&cnt=6')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          this.parseDetailInfo(data)
        })
    }
  }
}
</script>

<style>
</style>
